import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './index.css'

const Header = () => (
  <div
    style={{
      background: 'rgb(17, 29, 39)',
      marginBottom: '1.45rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '1.45rem 1.0875rem',
      }}
    >
      <h1 style={{ margin: 0 }}>
        <Link
          to="/"
          style={{
            color: 'white',
            textDecoration: 'none',
          }}
        >
          <img src="//static.the-grid.org/r/R-64.png" alt="The Grid"/>
        </Link>
      </h1>
    </div>
  </div>
)

const Footer = () => (
    <div
        style={{
            margin: '0 auto',
            maxWidth: 960,
            padding: '1.45rem 1.0875rem',
            textAlign: 'center',
        }}
    >
        <hr/>
        <div><a href="https://the-grid.org/login">Sign up</a> | <a href="https://the-grid.org/login">Log in</a> | <a href="https://faq.the-grid.org/">FAQ</a> | <a href="https://support.the-grid.org/">Support</a> | <Link to="/privacy-policy/">Privacy Policy</Link></div>
    </div>
)

const TemplateWrapper = ({ children }) => (
  <div>
    <Helmet
      title="Welcome to The Grid"
      meta={[
        { name: 'description', content: 'The Grid is a Resistance only resource.' },
      ]}
    />
    <Header />
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
        padding: '0px 1.0875rem 1.45rem',
        paddingTop: 0,
      }}
    >
      {children()}
    </div>
    <Footer />
  </div>
)

TemplateWrapper.propTypes = {
  children: PropTypes.func,
}

export default TemplateWrapper



// WEBPACK FOOTER //
// ./src/layouts/index.js